import TrainingBespoke from "./TrainingBespoke";

export default TrainingBespoke;
